// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsAndConditions_container__o5hYS {
  animation: TermsAndConditions_init__gOdDO 0.5s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsContainer__78Phf {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsContainer__78Phf .TermsAndConditions_loader__DJ20V {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsContainer__78Phf .TermsAndConditions_termsTitle__yZ6f0 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  width: 90%;
  margin-bottom: 30px;
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsTitle__yZ6f0 .TermsAndConditions_title__VA-Bn {
  margin-left: 10px;
  font-size: 1.5rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsTitle__yZ6f0 .TermsAndConditions_createButton__s4ncY {
  transition: 0.3s;
  width: 10%;
  height: 2.5rem;
  margin-inline: 10px;
  font-weight: 400;
  font-size: 1rem;
  text-decoration: none;
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsTitle__yZ6f0 .TermsAndConditions_createButton__s4ncY .TermsAndConditions_btn__fYBzb {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.TermsAndConditions_btn__fYBzb:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.05;
  filter: brightness(1.2);
}

.TermsAndConditions_insertPaginate__GlKJ9 {
  width: 30px;
  height: 30px;
}

.TermsAndConditions_insertPaginateButton__HhRTf {
  width: 30px;
  height: 30px;
}

.TermsAndConditions_btn__fYBzb:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.05;
  filter: brightness(1.2);
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsContainer__78Phf .TermsAndConditions_tableContainer__nWvsZ {
  width: 90%;
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsContainer__78Phf .TermsAndConditions_tableContainer__nWvsZ .TermsAndConditions_table__Z5f1s {
  width: 100%;
  border-radius: 10px 10px 10px 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsContainer__78Phf .TermsAndConditions_tableContainer__nWvsZ .TermsAndConditions_table__Z5f1s .TermsAndConditions_tableBody__KrLgd .TermsAndConditions_tableCell__FD5O4 {
  font-family: Roboto, sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  border-bottom: 1px solid rgba(0, 0, 0, 0.455);
}

.TermsAndConditions_container__o5hYS .TermsAndConditions_termsContainer__78Phf .TermsAndConditions_tableContainer__nWvsZ .TermsAndConditions_tableCellHeader__GA\\+8n {
  font-size: 0.9rem;
}

.TermsAndConditions_container_terminos__qU14d {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.TermsAndConditions_LinkRow__jPv80 {
  text-decoration: none;
  width: 100%;
  list-style: none;
}

@keyframes TermsAndConditions_init__gOdDO {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/TermsAndConditions/index.module.css"],"names":[],"mappings":"AAAA;EACE,8CAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.container .termsContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .termsContainer .loader {\n  height: 400px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .termsContainer .termsTitle {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 10px;\n  width: 90%;\n  margin-bottom: 30px;\n}\n\n.container .termsTitle .title {\n  margin-left: 10px;\n  font-size: 1.5rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .termsTitle .createButton {\n  transition: 0.3s;\n  width: 10%;\n  height: 2.5rem;\n  margin-inline: 10px;\n  font-weight: 400;\n  font-size: 1rem;\n  text-decoration: none;\n}\n\n.container .termsTitle .createButton .btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n}\n\n.btn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.05;\n  filter: brightness(1.2);\n}\n\n.insertPaginate {\n  width: 30px;\n  height: 30px;\n}\n\n.insertPaginateButton {\n  width: 30px;\n  height: 30px;\n}\n\n.btn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.05;\n  filter: brightness(1.2);\n}\n\n.container .termsContainer .tableContainer {\n  width: 90%;\n}\n\n.container .termsContainer .tableContainer .table {\n  width: 100%;\n  border-radius: 10px 10px 10px 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .termsContainer .tableContainer .table .tableBody .tableCell {\n  font-family: Roboto, sans-serif;\n  font-size: 0.9rem;\n  font-weight: 400;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.455);\n}\n\n.container .termsContainer .tableContainer .tableCellHeader {\n  font-size: 0.9rem;\n}\n\n.container_terminos {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.LinkRow {\n  text-decoration: none;\n  width: 100%;\n  list-style: none;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TermsAndConditions_container__o5hYS`,
	"init": `TermsAndConditions_init__gOdDO`,
	"termsContainer": `TermsAndConditions_termsContainer__78Phf`,
	"loader": `TermsAndConditions_loader__DJ20V`,
	"termsTitle": `TermsAndConditions_termsTitle__yZ6f0`,
	"title": `TermsAndConditions_title__VA-Bn`,
	"createButton": `TermsAndConditions_createButton__s4ncY`,
	"btn": `TermsAndConditions_btn__fYBzb`,
	"insertPaginate": `TermsAndConditions_insertPaginate__GlKJ9`,
	"insertPaginateButton": `TermsAndConditions_insertPaginateButton__HhRTf`,
	"tableContainer": `TermsAndConditions_tableContainer__nWvsZ`,
	"table": `TermsAndConditions_table__Z5f1s`,
	"tableBody": `TermsAndConditions_tableBody__KrLgd`,
	"tableCell": `TermsAndConditions_tableCell__FD5O4`,
	"tableCellHeader": `TermsAndConditions_tableCellHeader__GA+8n`,
	"container_terminos": `TermsAndConditions_container_terminos__qU14d`,
	"LinkRow": `TermsAndConditions_LinkRow__jPv80`
};
export default ___CSS_LOADER_EXPORT___;
